import angular from 'angular';

import DateExtended from "serviceJs/date.service.ts";

angular.module('folkeuni').component('tickets', {
  bindings: {
    currentOrderline: '=',
    product: '<'
  },
  templateUrl: '/shop-dist/templates/tickets.html?c=' + window.cacheBurst,
  transclude: false,
  controller: function (Cart, $filter, $log, $timeout) {
    var $ctrl = this;
    var errorTimer = null;
    $ctrl.courses = [];
    $ctrl.tickets = [];
    $ctrl.errorTimer = null;

    $ctrl.$onInit = function () {



      for (var i = 0; $ctrl.product.courses.length > i; i++) {
        var currentCourse = $ctrl.product.courses[i];

        if (currentCourse.available > 0 && !currentCourse.cancelled) {
          var currentCourseTickets = [];

          angular.copy($ctrl.product.prices,currentCourseTickets);

          var courseObj = {
              id: currentCourse.id,
              startDate: $filter("date")(currentCourse.events[0].startDate, "dd.MM.yyyy kl. HH:mm"),
              startDateFormattet: new DateExtended(currentCourse.events[0].startDate).format(
                  "[dddd] d. [DD].[MM].[YYYY] kl. [HH]:[mm]"
              ),
              location: currentCourse.events[0].location,
              tickets: currentCourseTickets,
              events: currentCourse.events,
              duration: currentCourse.events.filter((event) => {
                  return !event.cancelled;
              }).length
          };
          $ctrl.courses.push(courseObj);
        }
      }
    }

    $ctrl.stepBack = function () {
      $ctrl.currentOrderline.step = 0;
    }


    $ctrl.stepNext = function () {


      var ticketCount = 0;
      $ctrl.statusMessage = null;
      $ctrl.loading = true;

      var currentCartObj = {
        productId: $ctrl.product.id,
        courseId: $ctrl.courses[0].id,
        items: []
      }

      for (var i in $ctrl.courses[0].tickets) {
        var currentTicketType = $ctrl.courses[0].tickets[i],
          currentTicketTypeObj = {
            type: currentTicketType.type,
            quantity: currentTicketType.amount ? currentTicketType.amount : 0
          }

        if (currentTicketTypeObj.quantity) {
          ticketCount += currentTicketTypeObj.quantity;
        }
        currentCartObj.items.push(currentTicketTypeObj);
      }
      if (window.Clerk != null) {
        window.Clerk('cart', 'add', currentCartObj.productId);
      }

      if (ticketCount > 0) {
        Cart.validate(currentCartObj).then(function (successObj) {
          $ctrl.loading = false;
          $timeout.cancel($ctrl.errorTimer);
          $ctrl.statusMessage = null;
          //Generate tickets
          for (var z = 0; $ctrl.courses.length > z; z++) {
            var currentCourse = $ctrl.courses[z];

            for (var i = 0; currentCourse.tickets.length > i; i++) {
              var currentTicketType = currentCourse.tickets[i],
                currentTicketTypeCount = 0,
                foundMatch = false;

              for (var y = $ctrl.currentOrderline.tickets.length - 1; y >= 0; y--) {
                var currentTicket = $ctrl.currentOrderline.tickets[y];
                if (currentTicket.type == currentTicketType.type && currentTicket.courseId == currentCourse.id) {
                  //If user clicks back and adjust amount of ticket to a lower amount than earlier
                  if (currentTicketTypeCount < currentTicketType.amount) {
                    currentTicketTypeCount++;
                    foundMatch = true;
                  } else {
                    $ctrl.currentOrderline.tickets.splice(y, 1);
                  }
                };
              }

              for (var y = currentTicketTypeCount; currentTicketType.amount > y; y++) {
                var ticketObj = {
                  courseId: currentCourse.id,
                  title: currentTicketType.description,
                  type: currentTicketType.type,
                  accessories: []
                }
                $ctrl.currentOrderline.tickets.push(ticketObj);
              }
            };
          }
          if ($ctrl.product.options.length < 1) {
            $ctrl.currentOrderline.addToCart();
          } else if ($ctrl.currentOrderline.tickets && $ctrl.currentOrderline.tickets.length > 0) {
            $ctrl.currentOrderline.step = 1;
          }
        }, function (errorObj) {
          $ctrl.loading = false;
          if (errorObj.status == 409) {
            $ctrl.statusMessage = "Der er ikke det ønsket antal ledige pladser tilbage på holdet.";

            $ctrl.errorTimer = $timeout(function () {
              $ctrl.statusMessage = null;
            }, 5000);
          }
          else {
            $ctrl.statusMessage = errorObj.data;

            $ctrl.errorTimer = $timeout(function () {
              $ctrl.statusMessage = null;
            }, 5000);
          }
          console.log("error", errorObj);
        });
      } else {
        $ctrl.loading = false;
        $ctrl.statusMessage = "Du skal tilføje nogle billetter for at fortsætte.";
        $ctrl.errorTimer = $timeout(function () {
          $ctrl.statusMessage = null;
        }, 5000)
      }
    }
  }
});
